import React from 'react'
import PropTypes from 'prop-types'
import { useGoogleAnalytics } from '../components'

const BlankLayout = ({ children }) => {
	useGoogleAnalytics()
	return <div>{children}</div>
}

BlankLayout.propTypes = {
	children: PropTypes.any,
}

export default BlankLayout
